import { render, staticRenderFns } from "./BannerSuccess.vue?vue&type=template&id=5f55622a&scoped=true&"
import script from "./BannerSuccess.vue?vue&type=script&lang=js&"
export * from "./BannerSuccess.vue?vue&type=script&lang=js&"
import style0 from "./BannerSuccess.vue?vue&type=style&index=0&id=5f55622a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f55622a",
  null
  
)

export default component.exports